import { FC, useEffect } from 'react'

import { useMediaQuery } from 'shared/hooks/useMediaQuery'
import { useDesktopUtilityWindowsStore } from 'shared/stores/desktopUtilityWindowsStore'
import { useLaunchpadStore } from 'shared/stores/launchpadStore'
import { useNotificationStore } from 'shared/stores/notificationStore'

import { LaunchPadProps } from './LaunchPad.types'
import { LaunchPadDesktop } from './desktop/LaunchPadDesktop'
import { LaunchPadMobile } from './mobile/LaunchPadMobile'

export const LaunchPad: FC<LaunchPadProps> = props => {
  const { isMobile } = useMediaQuery()

  const isOpen = useLaunchpadStore(state => state.isOpen)
  const setNotificationPaneState = useNotificationStore(
    state => state.setNotificationPaneState
  )
  const closeDesktopUtilityWindow = useDesktopUtilityWindowsStore(
    state => state.closeWindow
  )

  useEffect(() => {
    if (isOpen) {
      setNotificationPaneState('closed')
      closeDesktopUtilityWindow()
    }
  }, [isOpen, setNotificationPaneState, closeDesktopUtilityWindow])

  const Component = isMobile ? LaunchPadMobile : LaunchPadDesktop

  return <Component {...props} />
}
